import { Injectable, signal } from '@angular/core';

const CLOSE_DELAY_MS = 180;

@Injectable({ providedIn: 'root' })
export class FlyoutCoordinatorService {

    public readonly $activeFlyoutId = signal<string | null>(null);

    private closeTimer: ReturnType<typeof setTimeout> | null = null;

    public open(id: string): void {

        this.cancelClose();
        this.$activeFlyoutId.set(id);
    }

    public scheduleClose(): void {

        this.cancelClose();
        this.closeTimer = setTimeout(() => {
            this.$activeFlyoutId.set(null);
            this.closeTimer = null;
        }, CLOSE_DELAY_MS);
    }

    public cancelClose(): void {

        if (this.closeTimer != null) {
            clearTimeout(this.closeTimer);
            this.closeTimer = null;
        }
    }

    public closeAll(): void {

        this.cancelClose();
        this.$activeFlyoutId.set(null);
    }
}
